import { render, staticRenderFns } from "./ContactDesk.vue?vue&type=template&id=7ef51db0&scoped=true&"
import script from "./ContactDesk.vue?vue&type=script&lang=js&"
export * from "./ContactDesk.vue?vue&type=script&lang=js&"
import style0 from "./ContactDesk.vue?vue&type=style&index=0&id=7ef51db0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef51db0",
  null
  
)

export default component.exports